<template>
  <v-container class="mt-3">
    <!-- <v-layout class="align-center justify-centeri">
        <v-flex xs12> -->
    <div>
      <v-data-table
        :headers="headers"
        :items="ambulances"
        :page.sync="page"
        :items-per-page="5"
        :search="search"
        @page-count="pageCount = $event"
        class="elevation-1 pa-3 font-weight-regular blue--text text--darken-4">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Ambulâncias</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="primary font-weight-regular"
              dark
              class="mb-2"
              @click="$router.push('/newambulance')"><v-icon size="25" left>
              add
            </v-icon>Adicionar novo
            </v-btn>
          </v-toolbar>
          <v-spacer></v-spacer>
          <v-text-field
            class="mx-4 mb-5"
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :class="getTextColor(item.status)"
            label
            :color="getColor(item.status)"
            dark>
            {{ item.status && item.status === 1 ? "Ativo": item.status === 0 ? "Desativado" : "Pendente" }}
          </v-chip>
        </template>

        <template v-slot:[`item.date`]="{ item }">
          {{formateDate(item)}}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            class="mr-2"
            @click="editItem(item)">
            mdi-pencil
          </v-icon>

          <v-tooltip v-if="item.status === 1" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                color="error"
                @click="disableItem(item)">
                drive_eta
              </v-icon>
            </template>
            <span>Desabilitar Ambulância</span>
          </v-tooltip>
          <v-tooltip v-else-if="item.status === 0" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="success" v-bind="attrs" v-on="on" @click="enableItem(item)">drive_eta</v-icon>
            </template>
            <span>Habilitar Ambulância</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination
          v-model="page"
          :length="pageCount">
        </v-pagination>
      </div>
    </div>
  </v-container>

</template>

<script>
var moment = require('moment')
export default {
  data: () => ({
    search:'',
    dialog: false,
    page: 1,
    pageCount: 0,
    headers: [
      { text: 'VTR', value: 'name', align: 'start', sortable: false},
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Tipo', value: 'type', sortable: false },
      { text: 'Placa', value: 'license', sortable: false },
      { text: 'Base', value: 'base.name', sortable: false },
      { text: 'Data de Registro', value: 'date', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      vtr: '',
      type: '',
      placa: '',
      date: '',
      base:'',
    },
    defaultItem: {
      vtr: '',
      type: '',
      placa: '',
      date: '',
      base:'',
    },
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nova Viatura' : 'Editar Viatura'
    },
    ambulances(){
      console.log(this.$store.getters.ambulances)
      return this.$store.getters.ambulances
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  created (){
    this.initialize();
  },

  methods: {

    formateDate (item) {
      if (item.updated_at){
        return new Date(item.updated_at).toLocaleString();
      }
      else{
        return new Date(item.created_at).toLocaleString();
      }

    },

    getColor (status) {
      if (status === 1) return 'green lighten-4'
      else if (status === 0) return 'red lighten-4'
      else return 'amber lighten-4'
    },

    getTextColor (status) {
      if (status === 1) return 'green--text'
      else if (status === 0) return 'red--text'
      else return 'orange--text'
    },
    async disableItem (item) {
      console.log('Verificar se API foi atualizado',item)
      item.status = 0;
      let novo = {
        status: item.status,
        id: item.id
      }
      let res = await this.$store.dispatch('editAmbulance', novo);
    },

    async enableItem (item) {
      console.log('Verificar se API foi atualizado',item)
      item.status = 1;
      let novo = {
        status: item.status,
        id: item.id
      }
      let res = await this.$store.dispatch('editAmbulance', novo);
    },

    editItem (item) {
      this.editedIndex = this.ambulances.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.$store.dispatch('setSelectedAmbulance',item)
      this.$router.push(`/editambulance/${this.editedIndex}`)
    },

    deleteItem (item) {
      const index = this.ambulances.indexOf(item)
      if(confirm('Você tem certeza que dejesa remover essa ambulância ?')){
        this.$store.dispatch('removeAmbulance',index)
      }
    },

    async initialize (){
      await this.$store.dispatch("downloadAmbulance")
    },
  },
}
</script>

<style scoped>

</style>
